import React, { ReactNode, useState, useEffect, useLayoutEffect } from "react";
import Box from "@material-ui/core/Box";
import Hidden from "@material-ui/core/Hidden";

import { colorAuthBackground } from "../../../constants/theme";
import {useMediaQuery} from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";
import {useLocation} from "react-router";

type Props = {
	children: ReactNode
}
const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};


const Auth: React.FC<Props> = ({children}: Props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    return (
        <>
            <Box
                height="100%"
                bgcolor={colorAuthBackground}
            >
                <Hidden xsDown>
                    <Box
                        position="fixed"
                        marginLeft="auto"
                        marginRight="auto"
                        left="0"
                        right="0"
                        textAlign="center"
                        width="100%"
                        zIndex="0"
                    >
                        {/* 90% so it's not going through borders of window */}
                    </Box>
                </Hidden>
                <Box
                >
                    {children}
                </Box>
            </Box>
        </>
    );
};

export default Auth;
